export function initGsapAnimations() {
  var gsap = window.gsap;
  var ScrollTrigger = window.ScrollTrigger;
  if (!gsap || !ScrollTrigger) return;
  gsap.registerPlugin(ScrollTrigger);

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Loading Sequence */
  var loader = document.getElementById('mj-loader');
  var hero = document.querySelector('.mj-hero');
  var loaderAlreadyShown = sessionStorage.getItem('mj_loader_shown');

  function skipLoader() {
    if (loader) loader.classList.add('is-done');
    document.body.classList.remove('is-loading');
    document.querySelectorAll('.mj-clip__inner').forEach(function (el) {
      el.style.transform = 'translateY(0)';
    });
  }

  function runIntro() {
    if (reducedMotion || loaderAlreadyShown) {
      skipLoader();
      if (!reducedMotion && hero) {
        var clips = hero.querySelectorAll('.mj-clip__inner');
        clips.forEach(function (c) { gsap.set(c, { y: 0 }); });
        var vertical = hero.querySelector('.mj-hero__vertical');
        var scroll = hero.querySelector('.mj-hero__scroll');
        if (vertical) gsap.set(vertical, { opacity: 1, x: 0 });
        if (scroll) gsap.set(scroll, { opacity: 1 });
      }
      return;
    }

    sessionStorage.setItem('mj_loader_shown', 'true');

    var tl = gsap.timeline({
      onComplete: function () {
        document.body.classList.remove('is-loading');
      }
    });

    if (loader) {
      var logo = loader.querySelector('.mj-loader__logo');
      tl.to(logo, { opacity: 1, duration: 0.5, ease: 'power2.out' })
        .to(logo, { opacity: 0, duration: 0.3, delay: 0.4 })
        .to(loader, { opacity: 0, duration: 0.6, ease: 'power2.inOut',
          onComplete: function () { loader.classList.add('is-done'); }
        }, '-=0.1');
    }

    if (hero) {
      // Luminous Atmosphere Edition: 要素の取得
      var visualBg = hero.querySelector('.mj-hero__visual-bg');
      var nebulaWrap = hero.querySelector('.mj-hero__nebula-wrap');
      var flowCanvas = hero.querySelector('.mj-hero__flow-canvas');
      var orbs = hero.querySelectorAll('.mj-hero__orb');
      var prismLayer = hero.querySelector('.mj-hero__prism-layer');
      var luminousPaths = hero.querySelectorAll('.mj-hero__luminous-path');
      var atmosSurface = hero.querySelector('.mj-hero__atmos-surface');
      var clips = hero.querySelectorAll('.mj-clip__inner');
      var vertical = hero.querySelector('.mj-hero__vertical');
      var scroll = hero.querySelector('.mj-hero__scroll');

      // 背景演出: すべて絶対時間で並列スタート（テキストをブロックしない）
      if (visualBg)       tl.fromTo(visualBg,       { opacity: 0 }, { opacity: 0.8, duration: 2.5, ease: 'power2.out' }, 0);
      if (nebulaWrap)     tl.fromTo(nebulaWrap,     { opacity: 0 }, { opacity: 0.6, duration: 3,   ease: 'power2.out' }, 0.1);
      if (flowCanvas)     tl.fromTo(flowCanvas,     { opacity: 0, scale: 0.95 }, { opacity: 1, scale: 1, duration: 2.5, ease: 'expo.out' }, 0.1);
      if (orbs.length)    tl.fromTo(orbs,           { opacity: 0, scale: 0.5, y: 30 }, { opacity: 0.15, scale: 1, y: 0, duration: 2.5, stagger: 0.3, ease: 'power2.out' }, 0.2);
      if (prismLayer)     tl.fromTo(prismLayer,     { opacity: 0 }, { opacity: 1, duration: 3 }, 0.3);
      if (luminousPaths.length) tl.fromTo(luminousPaths, { opacity: 0 }, { opacity: 0.4, duration: 3, stagger: 0.2, ease: 'power2.out' }, 0.4);
      if (atmosSurface)   tl.fromTo(atmosSurface,   { opacity: 0 }, { opacity: 1, duration: 2 }, 0.5);

      // テキスト: ローダーが消え始める頃（1.2s）に出現
      clips.forEach(function (c, i) {
        tl.to(c, { y: 0, duration: 0.8, ease: 'power3.out' }, 1.2 + i * 0.15);
      });

      if (vertical) {
        tl.fromTo(vertical, { opacity: 0, x: 20 },
          { opacity: 1, x: 0, duration: 0.6, ease: 'power2.out' }, 2.0);
      }
      if (scroll) {
        tl.fromTo(scroll, { opacity: 0 },
          { opacity: 1, duration: 0.5 }, 2.3);
      }
    }
  }

  if (document.readyState === 'complete') {
    runIntro();
  } else {
    window.addEventListener('load', runIntro);
  }

  if (reducedMotion) return;


  /* Section headers */
  var isFrontPage = document.querySelector('.mj-hero') !== null;
  var headerDelay = isFrontPage ? 1.5 : 0.2;
  document.querySelectorAll('.mj-section__header').forEach(function (el) {
    var rect = el.getBoundingClientRect();
    if (rect.top < window.innerHeight) {
      gsap.set(el, { opacity: 0, y: 24 });
      gsap.to(el, { opacity: 1, y: 0, duration: 0.6, ease: 'power2.out', delay: headerDelay });
    } else {
      gsap.set(el, { opacity: 0, y: 32 });
      ScrollTrigger.create({
        trigger: el, start: 'top 85%', once: true,
        onEnter: function () {
          gsap.to(el, { opacity: 1, y: 0, duration: 0.6, ease: 'power2.out' });
        },
      });
    }
  });

  /* Reveal elements */
  var revealDelay = isFrontPage ? 1.6 : 0.2;
  document.querySelectorAll('.mj-reveal').forEach(function (el) {
    if (el.closest('.mj-hero')) return;
    if (el.closest('.mj-cta')) return;
    var rect = el.getBoundingClientRect();
    if (rect.top < window.innerHeight) {
      gsap.set(el, { opacity: 0, y: 20 });
      gsap.to(el, { opacity: 1, y: 0, duration: 0.5, ease: 'power2.out', delay: revealDelay });
    } else {
      gsap.set(el, { opacity: 0, y: 24 });
      ScrollTrigger.create({
        trigger: el, start: 'top 92%', once: true,
        onEnter: function () {
          gsap.to(el, { opacity: 1, y: 0, duration: 0.5, ease: 'power2.out' });
        },
      });
    }
  });

  /* CTA Section Entrance & Shapes */
  var ctaSection = document.querySelector('.mj-cta__display');
  if (ctaSection) {
    var ctaDisplay = ctaSection.querySelector('.mj-cta__display-text');
    var ctaSub = ctaSection.querySelector('.mj-cta__display-sub');
    var ctaBtns = ctaSection.querySelector('.mj-cta__buttons');
    var ctaShapes = ctaSection.querySelectorAll('.mj-cta__shape');

    if (ctaDisplay) gsap.set(ctaDisplay, { opacity: 0, scale: 0.98 });
    if (ctaSub) gsap.set(ctaSub, { opacity: 0, y: 16 });
    if (ctaBtns) gsap.set(ctaBtns, { opacity: 0, y: 12 });
    if (ctaShapes.length) gsap.set(ctaShapes, { opacity: 0, scale: 0, rotation: -20 });

    ScrollTrigger.create({
      trigger: ctaSection, start: 'top 88%', once: true,
      onEnter: function () {
        var tl = gsap.timeline();
        if (ctaDisplay) tl.to(ctaDisplay, { opacity: 0.12, scale: 1, duration: 0.8, ease: 'power2.out' });
        if (ctaSub) tl.to(ctaSub, { opacity: 1, y: 0, duration: 0.5, ease: 'power2.out' }, '-=0.4');
        if (ctaBtns) tl.to(ctaBtns, { opacity: 1, y: 0, duration: 0.4, ease: 'power2.out' }, '-=0.3');
        
        if (ctaShapes.length) {
          tl.to(ctaShapes, { 
            opacity: function(i, el) { return el.classList.contains('mj-cta__shape--ring') || el.classList.contains('mj-cta__shape--circle-sm') ? 0.15 : 0.25; }, 
            scale: 1, 
            rotation: 0, 
            duration: 1, 
            stagger: 0.1, 
            ease: 'back.out(1.7)' 
          }, '-=0.5');
        }
      },
    });
  }

  /* CTA Shapes Parallax (Complementing CSS floating) */
  document.querySelectorAll('.mj-cta__shape').forEach(function (s, i) {
    var speed = 30 + (i * 10);
    gsap.to(s, {
      y: -speed,
      rotation: i % 2 === 0 ? 20 : -20,
      scrollTrigger: { trigger: s.parentElement, start: 'top bottom', end: 'bottom top', scrub: 1.5 },
    });
  });

  /* Mobile fixed CTA */
  var fixedCta = document.getElementById('mj-fixed-cta');
  if (fixedCta && hero) {
    gsap.set(fixedCta, { y: 80, opacity: 0 });
    ScrollTrigger.create({
      trigger: hero, start: 'bottom 80%',
      onEnter: function () { gsap.to(fixedCta, { y: 0, opacity: 1, duration: 0.3, ease: 'power2.out' }); },
      onLeaveBack: function () { gsap.to(fixedCta, { y: 80, opacity: 0, duration: 0.2 }); },
    });
  }

  /* About Stack Card Carousel */
  var aboutCarousel = document.getElementById('mj-about-carousel');
  if (aboutCarousel) {
    var cards = aboutCarousel.querySelectorAll('.mj-about__card');
    var prevBtn = document.getElementById('mj-about-prev');
    var nextBtn = document.getElementById('mj-about-next');
    var activeIndex = 0;
    var totalCards = cards.length;

    function updateCards() {
      cards.forEach(function (card, i) {
        card.setAttribute('data-offset', (i - activeIndex + totalCards) % totalCards);
      });
    }
    function goNext() { activeIndex = (activeIndex + 1) % totalCards; updateCards(); }
    function goPrev() { activeIndex = (activeIndex - 1 + totalCards) % totalCards; updateCards(); }

    if (nextBtn) nextBtn.addEventListener('click', goNext);
    if (prevBtn) prevBtn.addEventListener('click', goPrev);
    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        var idx = parseInt(card.getAttribute('data-index'), 10);
        if (idx !== activeIndex) { activeIndex = idx; updateCards(); }
      });
    });
    updateCards();
  }

  /* Section Background Color Change */
  document.querySelectorAll('.mj-section[data-bg]').forEach(function (sec) {
    ScrollTrigger.create({
      trigger: sec, start: 'top 60%', end: 'bottom 40%',
      onEnter: function () { document.body.style.background = sec.dataset.bg; },
      onLeaveBack: function () { document.body.style.background = ''; },
      onLeave: function () { document.body.style.background = ''; },
    });
  });
}
